import yup from '../../../config/yup';

export const odataReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('odataReader'),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    url: yup.string().required('URL is required'),
    httpMethod: yup.string().oneOf(['GET', 'POST', 'PUT', 'DELETE']),
    headers: yup.string(),
  }),
});
